import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home/home.vue'

Vue.use(Router)

export default new Router({
  scrollBehavior: () => ({
    y: 0
  }),
  linkActiveClass: 'active',
  // routes: [{
  //   path: '/',
  //   name: 'Home',
  //   component: Home,
  //   redirect: '/homeContent',
  //   children: [{
  //     path: '/homeContent',
  //     name: 'homeContent',
  //     component: () => import('@/pages/home/home/homeContainer')
  //   },
  //   {
  //     path: '/homeDetails',
  //     name: 'detailsContainer',
  //     component: () => import('@/pages/home/homeDetails/detailsContainer')
  //   }]
  // }]

  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      redirect: '/homeContent',
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import('@/pages/index/login')
        },
        // 第一屏 首页
        {
          path: '/homeLogin',
          name: 'homeLogin',
          component: () => import('@/pages/home/homeList/homeLogin')
        },
        // 第二屏 安全
        {
          path: '/homeSecurity',
          name: 'homeSecurity',
          component: () => import('@/pages/home/homeSecurity/homeSecurity')
        },
        // 第三屏 暂时空 人、车、货、路理念图
        // {

        // },
        // 第四屏 概览大屏
        {
          path: '/homeContent',
          name: 'homeContent',
          component: () => import('@/pages/home/home/homeContainer')
        },
        // 第五屏 单车大屏
        {
          path: '/detailsContainer/:licensePlate',
          name: 'detailsContainer',
          component: () => import('@/pages/home/homeDetails/detailsContainer')
        // props: { default: true }
        // props: (route) => ({ licensePlate: route.query.licensePlate })
        }
      ]
    }]
})
